<template>
  <div>
    <div class="card card-body mb-3"
         v-for="(membership, index) in user.memberships"
         :key="membership.organisation.slug"
    >
      <div class="row">
        <div class="col-md-2">
          <div class="w-100 d-flex justify-content-center">
            <img
              :src="membership.organisation.logo"
              alt=""
              class="d-block img-logo img-fluid mb-3 mb-md-0"
              v-if="membership.organisation.logo"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="h-100 d-flex align-items-center justify-content-center">
            <h4 class="m-0 mr-3 mb-3 mb-md-0">
              {{ membership.organisation.name }}
            </h4>
          </div>
        </div>
        <div class="col-md-2">
          <div class="w-100 h-100 d-flex align-items-center">
            <div class="w-100">
              <v-button
                :id="`switch-to-organisation-${index}`"
                :style-type="org.slug === membership.organisation.slug? 'secondary' : 'primary'"
                size="sm"
                :disabled="org.slug === membership.organisation.slug"
                :text="buttonText(membership.organisation.slug)"
                @click="switchToOrganisation(membership.organisation, membership.id)"
                :block="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="loading">
      <v-loader
        v-if="loading"
      />
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import Button from '@/common/components/Button.vue';
import { updateOrganisationMember } from '@/organisation/api';
import Loader from '@/common/components/Loader.vue';
import { notify } from '@/common/utils/notify';

export default {
  name: 'OrganisationList',
  components: {
    'v-button': Button,
    'v-loader': Loader,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'org']),
  },
  methods: {
    ...mapActions(['refreshUser']),
    async switchToOrganisation(organisation, membershipId) {
      this.loading = true;
      const response = await updateOrganisationMember(membershipId, { primary: true });
      if (response.status === 200) {
        await this.refreshUser();
        notify(this.$t('phrase.switched_to', { orgName: organisation.name }));
        await this.$router.push({ name: 'organisation-dashboard' });
      } else {
        this.loading = false;
      }
    },
    buttonText(slug) {
      if (slug === this.org.slug) {
        return this.$t('word.selected');
      }
      return this.$t('word.open');
    },
  },
  created() {
    setBreadcrumbs('organisation.organisationList');
  },
};
</script>

<style scoped>
.img-logo {
  max-height: 50px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 250px;
  right: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 991px) {
  .overlay {
    left: 0;
  }
}
</style>
